import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  ProProfile,
  ruleLength,
  SelectedPro,
  type,
} from 'src/ts/interfaces/profile.interface';
import { PlatformService } from 'src/services/platform/platform.service';
import { ContextService } from 'src/services/platform/context.service';

@Component({
  selector: 'app-all-skills',
  templateUrl: './all-skills.component.html',
  styleUrls: ['./all-skills.component.scss'],
})
export class AllSkillsComponent implements OnInit {
  proProfile = this.contextService.proProfile();
  // skills = this.contextService.profileData.skills
  skills: ProProfile[];
  devider: ProProfile[][] = [];
  jobFamily = this.contextService.profileData.jobFamily;
  selectedProProfile = this.contextService.selectedProProfile;
  ruleLength: ruleLength = {
    skills: 1,
  };
  languages = this.contextService.languages.allSkills;
  loading = true;
  @Output() change = new EventEmitter<any>();
  constructor(
    private platformService: PlatformService,
    private contextService: ContextService
  ) {
    this.filterSkills();
    this.platformService.reRender.subscribe((val) => {
      if (val === 'roles') {
        this.filterSkills();
      }
    });
  }

  filterSkills() {
    this.selectedProProfile.jobFamily.forEach((id) => {
      let family = this.jobFamily.find((x) => x.id === id);
      this.skills = this.contextService.profileData.skills.filter(
        (x) => x.family === family?.displayName
      );
    });
    this.skills.sort((a: any, b: any) => {
      if (a.displayName > b.displayName) {
        return 1;
      }
      if (a.displayName < b.displayName) {
        return -1;
      }
      return 0;
    });
    let chunkSize = 10;
    if (this.skills.length > 10) {
      chunkSize = Math.ceil(this.skills.length / 3);
    }
    this.devider = [];
    for (let i = 0; i < this.skills.length; i += chunkSize) {
      const chunk = this.skills.slice(i, i + chunkSize);
      this.devider.push(chunk);
    }
  }
  ngOnInit(): void {}

  validateChoices(type: string) {
    this.contextService.validSelection[type] = false;
    if (
      this.contextService.selectedProProfile[type as keyof SelectedPro]
        .length >= this.ruleLength[type]
    ) {
      this.contextService.validSelection[type] = true;
    }

    if (!this.contextService.validSelection[type]) {
      this.contextService.validSelection['topSkills'] = false;
    }
  }

  selectedPro = (id: number, type: keyof type, single?: boolean): void => {
    if (single) {
      this.selectedProProfile[type] = [];
    }
    let findex = this.selectedProProfile[type].findIndex((x) => x === id);

    if (findex === -1) {
      this.selectedProProfile[type].push(id);
    } else {
      this.selectedProProfile[type].splice(findex, 1);
      let findexTopSkills = this.selectedProProfile['topSkills'].findIndex(
        (x) => x === id
      );
      if (findexTopSkills !== -1) {
        this.selectedProProfile['topSkills'].splice(findexTopSkills, 1);
      }
    }

    this.selectedProProfile[type] = this.selectedProProfile[type].filter((x) =>
      this.skills.some((z) => z.id === x)
    );

    this.validateChoices(type);
    this.platformService.reRender.next('skills');
  };
}
